export default __webpack_public_path__ + "d0e5b39d96e32a8cf5c5b438e8125299.png";